<button
  [tabIndex]="tabIndex()"
  mat-icon-button
  [disabled]="disabled()"
  [attr.aria-label]="ariaLabel()"
  (click)="onClick.emit()">
  <mat-icon
    [fontSet]="icon().set"
    [fontIcon]="icon().name" />
</button>
